import PrivateRoute from "shared/authorization/PrivateRoute";
import Layout from "shared/components/Layout/Private";
import { PATHS } from "utils/constants";

import Account from "./Account";
import Actions from "./Actions";
import ContactUs from "./ContactUs";
import ContactUsNotification from "./ContactUsNotification";
import Files from "./Files";
import NewFolder from "./NewFolder";
import Regulations from "./Regulations";

import "./styles.scss";

const routes = [
  {
    path: PATHS.FILE.HOME,
    exact: true,
    component: Layout(Files),
  },
  {
    path: PATHS.FILE.NEW,
    exact: true,
    component: Layout(NewFolder),
  },
  {
    path: PATHS.FILE.REGULATIONS,
    exact: true,
    component: Layout(Regulations),
  },
  {
    path: PATHS.ACCOUNT,
    exact: true,
    component: Layout(Account),
  },
  {
    path: PATHS.FILE.CONTACTUS,
    exact: true,
    component: Layout(ContactUs),
  },
  {
    path: PATHS.FILE.CONTACT_US_NOTIFICATION,
    exact: true,
    component: Layout(ContactUsNotification),
  },
  {
    path: "/",
    exact: true,
    component: Layout(Files),
  },
  {
    path: PATHS.FILE.ACTIONS,
    exact: true,
    component: Layout(Actions),
  },
];

export default routes.map(({ component, ...rest }) => {
  return {
    component: () =>
      PrivateRoute({
        component,
      }),
    ...rest,
  };
});
